import { useEffect } from "react";
import { useLocation } from "wouter";
import { useAuth } from "@/hooks/use-auth";

type ProtectedRouteProps = {
  path: string;
  component: React.ComponentType;
};

export function ProtectedRoute({
  path,
  component: Component,
}: ProtectedRouteProps) {
  const { user, isLoading, defaultRoute, canAccess } = useAuth();
  const [, setLocation] = useLocation();
  const allowed = !!user && canAccess(path);

  useEffect(() => {
    if (isLoading) return;
    if (!user) {
      setLocation("/login");
      return;
    }
    if (!canAccess(path)) {
      setLocation(defaultRoute);
    }
  }, [isLoading, user, path, defaultRoute, canAccess, setLocation]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
        Loading...
      </div>
    );
  }

  if (!allowed) {
    return null;
  }

  return <Component />;
}
